import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UserManagementService } from 'src/app/Service/user-management.service';

@Component({
  selector: 'app-delete-product',
  templateUrl: './delete-product.component.html',
  styleUrls: ['./delete-product.component.scss']
})
export class DeleteProductComponent implements OnInit {

  formDelete: FormGroup;
  response;
  marketId;
  constructor(
    public dialogRef: MatDialogRef<DeleteProductComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private fb: FormBuilder, public _userService: UserManagementService, public toastr: ToastrService, private router: Router) { }

  ngOnInit(): void {
    this.formDelete = this.fb.group({
      Remark: ['', [Validators.required]],
    });
  }
  onSubmit(value: any) {
    if (this.formDelete.valid) {
      var deleteItems = {
        result: value,
        remark: this.formDelete.value.Remark

      }
      this.dialogRef.close(deleteItems);
    }
    else {
      alert("Please Enter the valid remark!")
    }
  }
  onNoClicks(value): void {
    this.dialogRef.close(value);
  }
}